import { AdminLaneSearchTable } from '../views/index';
import { TruckSearchResult } from '../dtos/index';

export const ADMIN_LANE_SEARCH_LIST_TABLE = (
	searchList: Array<TruckSearchResult> = []
): Array<AdminLaneSearchTable> => {
	let results: Array<AdminLaneSearchTable> = [];
	try {
		if (searchList.length > 0) {
			searchList.map((search) => {
				let row = {} as AdminLaneSearchTable;
				if (search.trucks.length > 0) {
					row.age = search.trucks[0].age;
					row.ageDeduction = search.trucks[0].rating.ageDeduction || 0;
					row.destinationDeduction = search.trucks[0].rating.destinationDeduction || 0;
					row.dh0 = search.trucks[0].originDeadhead || 0;
					row.dhD = search.trucks[0].originDeadhead || 0;
					row.match = search.trucks[0].rating.score || 0;
					row.origin =
						search.trucks[0].loadStops[0].address.city +
							' ' +
							search.trucks[0].loadStops[0].address.state || '';
					row.originDeduction = search.trucks[0].rating.originDeduction || 0;
					row.postedOn = search.trucks[0].postedOn;
					row.trailerType = search.trucks[0].trailerType;
				}
				row.businessName = search.carrier.businessName;
				row.carrierId = search.carrier.carrierHubId;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('ADMIN_LANE_SEARCH_LIST_TABLE error: ', error);
	}

	return results;
};
